<div id="MB-MenuParent" class="panel-group hidden-pc">
    <!-- 第一層 -->
    <div class="panel" *ngFor="let menu of menuList.children; let menuIndex= index;" [id]="'mgMenuIndex_'+menuIndex">

        <span (click)="toggleMainMenu($event,menu)" href="#"
            [ngClass]="{'fir_nav_m': true, 'collapsed' :!menu.expand}">{{menu.menuName}}</span>
        <div id="collapse4"
            [ngClass]="{'panel-collapse collapsed': true, 'in' :menu.expand, 'display-block': menu.expand, 'display-none': !menu.expand}">
            <ul class="sec_nav_m">
                <!-- 第二層 -->
                <ng-container *ngFor="let submenu of menu.children; let j = index;">
                    <li>
                        <span (click)="toggleSubMainMenu($event,submenu)"
                            [ngClass]="{'tre_nav_m_tit': true, 'collapsed' :!submenu.expand}"
                            href="#">{{submenu.menuName}}</span>
                        <div [ngClass]="{'panel-collapse': true, 'collapsed' :!submenu.expand, 'display-block': submenu.expand, 'display-none': !submenu.expand}"
                            *ngIf="submenu.children && submenu.children.length>0">
                            <ul class="tre_nav_m">
                                <li *ngFor="let submenu2 of submenu.children">
                                    <!-- 第三層 -->
                                    <ng-container *ngIf="!submenu2.children || submenu2.children.length===0">
                                        <span href="#" (click)="toggleSubMainMenu($event,submenu2)">
                                            {{submenu2.menuName}}
                                        </span>
                                    </ng-container>

                                    <ng-container *ngIf="submenu2.children && submenu2.children.length>0">
                                        <span [ngClass]="{'for_nav_m_tit': true, 'collapsed' :!submenu2.expand}"
                                            href="#" (click)="toggleSubMainMenu($event,submenu2)">
                                            {{submenu2.menuName}}
                                        </span>
                                        <!-- 第四層 -->
                                        <ul
                                            [ngClass]="{'forth_nav_m panel-collapse collapse': true, 'in' :submenu2.expand, 'display-block': submenu2.expand, 'display-none': !submenu2.expand}">
                                            <li *ngFor="let submenu3 of submenu2.children"
                                                (click)="toggleSubMainMenu($event,submenu3)">
                                                <span href="#">{{submenu3.menuName}}</span>
                                            </li>
                                        </ul>
                                    </ng-container>

                                </li>
                            </ul>
                        </div>
                    </li>
                </ng-container>

            </ul>
        </div>
    </div>
</div>